import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { Checkbox } from '@one-thd/sui-atomic-components';
import { ListTile } from '@thd-olt-component-react/list-tile';
import { useProductList } from '../../../hooks/useLists';

export const MiniListItem = ({
  list,
  isChecked,
  handleChange,
  isIndeterminate,
  handleOnSelect,
  onFetchListComplete,
  storeId
}) => {
  const [fetchedList, setFetchedList] = React.useState(null);

  const [fetchList, { data }] = useProductList({ storeId, lazy: true });

  useEffect(() => {
    if (data?.list && data.list.id === list.id) {
      setFetchedList(data);
      onFetchListComplete(list.id, data);
    }
  }, [data]);

  const onSelectionChange = (event) => {
    const { value: selectedListId } = event.target;
    if (selectedListId && !fetchedList) {
      fetchList({ variables: { id: selectedListId } });
    }
    handleChange(selectedListId);
  };

  return (
    <div
      className="sui-flex sui-items-center"
      data-testid="mini-list-tile"
    >
      <Checkbox
        checked={isChecked(list)}
        value={list.id}
        onChange={onSelectionChange}
        indeterminate={isIndeterminate(list)}
        inputAttributes={{ 'aria-label': 'controlled' }}
      />
      <div
        data-testid="mini-list-tile-wrapper"
        className="sui-cursor-pointer sui-w-full"
        onClick={() => handleOnSelect(list)}
      >
        <ListTile
          iconSize="small"
          listId={list.id}
          data={list}
          disableLink
          disableSettings
          numberOfThumbnails={4}
        />
      </div>
    </div>
  );
};

MiniListItem.propTypes = {
  list: PropTypes.shape({}).isRequired,
  isChecked: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  isIndeterminate: PropTypes.func.isRequired,
  handleOnSelect: PropTypes.func.isRequired,
  onFetchListComplete: PropTypes.func.isRequired,
  storeId: PropTypes.string.isRequired
};

MiniListItem.dataModel = extend(ListTile);
